// eslint-disable-next-line import/no-unresolved
const slickSlider = require('../components/slider');
const utils = require('../utils');

/**
 * Generates the modal window on the first call.
 *
 */

function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    const htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<div class="modal-dialog big quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <a class="full-pdp-link" href="">View Full Details</a>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        &times;'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));

    const body = $html.find('.product-quickview');
    const footer = $html.find('.modal-footer').children();

    return { body, footer };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('#quickViewModal')
        .find('.modal-body')
        .spinner()
        .start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success(data) {
            const parsedHtml = parseHtml(data.renderedTemplate);

            $('#quickViewModal')
                .find('.modal-body')
                .empty();
            $('#quickViewModal')
                .find('.modal-body')
                .html(parsedHtml.body);
            $('#quickViewModal')
                .find('.modal-footer')
                .html(parsedHtml.footer);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal').modal('show');
            $.spinner().stop();
        },
        error() {
            $.spinner().stop();
        },
    });

    $('#quickViewModal').on('shown.bs.modal', () => {
        const { prev, next } = utils.getSliderLabels();
        slickSlider.methods.useCustomizableSlick('.primary-images .gallery-slider', false, `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
            `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`, 1, {
                customPaging(slider, i) {
                    const video = $(slider.$slides[i]).find('.carousel-item img').data('video') ? 'thumbVideo' : 'tabThumb';
                    return `<button class="tab ${video}"><img src="${$(slider.$slides[i]).find('.carousel-item img').data('thumb')}" /></button>`;
                },
            });
    });
}

module.exports = {
    showQuickview() {
        $('body').on('click', '.quickview', (e) => {
            e.preventDefault();
            const selectedValueUrl = $(e.target)
                .closest('a.quickview')
                .attr('href');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);
        });
    },
    showSpinner() {
        $('body').on('product:beforeAddToCart', (e, data) => {
            $(data)
                .closest('.modal-content')
                .spinner()
                .start();
        });
    },
    hideDialog() {
        $('body').on('product:afterAddToCart', () => {
            $('#quickViewModal').modal('hide');
        });
    },
    beforeUpdateAttribute() {
        $('body').on('product:beforeAttributeSelect', () => {
            $('.modal.show .modal-content')
                .spinner()
                .start();
        });
    },
    updateAttribute() {
        $('body').on('product:afterAttributeSelect', (e, response) => {
            if (!$('#quickViewModal').length) {
                $('.tile-body-footer-buy:visible')
                    .find('.product-detail')
                    .data('pid', response.data.product.id);
            } else if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show')
                    .find(response.container)
                    .data('pid', response.data.product.id);
                $('.modal.show')
                    .find(response.container)
                    .find('.product-id')
                    .text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .full-pdp-link').attr(
                    'href',
                    response.data.product.selectedProductUrl,
                );
            }
        });
    },
    updateAddToCart() {
        $('body').on('product:updateAddToCart', (e, response) => {
            // TODO: check this enabled var and
            // if is necessary create some function *in this file*
            const enabled = false;
            // update local add to cart (for sets)
            if (enabled) {
                $('button.add-to-cart', response.$productContainer).attr(
                    'disabled',
                    !response.product.readyToOrder || !response.product.available,
                );

                // update global add to cart (single products, bundles)
                const dialog = $(response.$productContainer).closest('.quick-view-dialog');

                $('.add-to-cart-global', dialog).attr(
                    'disabled',
                    !$('.global-availability', dialog).data('ready-to-order')
                        || !$('.global-availability', dialog).data('available'),
                );
            }
        });
    },
    updateAvailability() {
        $('body').on('product:updateAvailability', (e, response) => {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);

            const dialog = $(response.$productContainer).closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                const allAvailable = $('.product-availability', dialog)
                    .toArray()
                    .every(item => $(item).data('available'));

                const allReady = $('.product-availability', dialog)
                    .toArray()
                    .every(item => $(item).data('ready-to-order'));

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog)
                    .empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    },
};
